import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter,withRouterConfig  } from '@angular/router';

import { routes } from './app.routes';
import { AuthModule } from '@core/auth/auth.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { OAuthService } from 'angular-oauth2-oidc';
import { LayoutModule } from './layout/layout.module';
import { Apollo } from 'apollo-angular';
import { PagesModule } from './pages/pages.module';
import { appInterceptor } from '@core/services/app-interceptor.service';
import { GraphQLModule } from '@shared/modules/graphql.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { provideNgxMask } from 'ngx-mask';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes), //withRouterConfig
    provideHttpClient(withInterceptors([appInterceptor])),
    importProvidersFrom(
      AuthModule,
      FormsModule,
      ReactiveFormsModule,
      HttpClient,
      BrowserModule,
      NgSelectModule,
      LayoutModule,
      PagesModule,
      BrowserAnimationsModule,
      ToastrModule.forRoot(),
      GraphQLModule,
      NgxDaterangepickerMd.forRoot()
    ),
    provideNgxMask(),
    DatePipe,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AppInterceptorService,
    //   multi: true,
    // },
  ],
};
